<template>
  <div v-if="!$route.path.match('/login')" id="app">
    <navigation-bar />
    <about-modal />
    <router-view />
  </div>
  <div v-else>
    <router-view />
  </div>
</template>

<script>
import NavigationBar from './components/shared/NavigationBar'
import AboutModal from './components/shared/AboutModal'

export default {
  components: {
    NavigationBar,
    AboutModal
  }
}
</script>

<style scoped>
#app {
  margin-top: 73px
}

</style>

<style lang="scss">
  .navbar-pf {
    background: #D24400 !important;
    border-top: 3px solid lighten(#D24400, 15%) !important;
    span {
       color: #ffffff !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/js/App.vue